import Text from '@raydiant/raydial/components/Text';
import Column from 'raydiant-elements/layout/Column';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ResourceACL, Device } from '@raydiant/api-client-js';
import ShareResource from '../../components/ShareResource';
import * as deviceActions from '../../actions/devices';

interface DeviceSharingProps {
  device: Device;
}

const DeviceSharing = ({ device }: DeviceSharingProps) => {
  const dispatch = useDispatch();

  const [resource, setResource] = useState(device.resource);

  // Callbacks

  const shareDevice = useCallback(
    async (profileId: string) => {
      return new Promise<void>((resolve, reject) => {
        dispatch(
          deviceActions.shareDevice(
            {
              deviceId: device.id,
              profileId,
            },
            {
              onShare: (res) => {
                const nextResource = {
                  ...resource,
                  r: {
                    ...resource.r,
                    resourceACLs: [...resource.r.resourceACLs, res],
                  },
                };
                setResource(nextResource);
                resolve();
              },
              onError: reject,
            },
          ),
        );
      });
    },
    [dispatch, device, resource],
  );

  const unShareDevice = useCallback(
    async (selectedACL: ResourceACL) => {
      return new Promise<void>((resolve) => {
        dispatch(
          deviceActions.removeDeviceResourceACL({
            deviceId: device.id,
            aclId: selectedACL.id,
          }),
        );

        const nextResource = {
          ...resource,
          r: {
            ...resource.r,
            resourceACLs: resource.r.resourceACLs.filter(
              (acl) => acl.id !== selectedACL.id,
            ),
          },
        };

        setResource(nextResource);

        resolve();
      });
    },
    [dispatch, device, resource],
  );

  // Render

  return (
    <Column>
      <Text variant="smallSubheader" className="text-black mb-3 flex">
        Sharing
      </Text>
      <ShareResource
        resource={resource}
        resourceType="screen"
        onShare={shareDevice}
        onUnshare={unShareDevice}
      />
    </Column>
  );
};

export default DeviceSharing;
